export const BADGE_TYPES = Object.freeze({
  DEFAULT: 'event',
  SOLD_OUT: 'soldout',
});
